export const GREEN = 'green'
export const ORANGE = 'orange'
export const RED = 'red'

export const GREEN_STATUS = 1
export const ORANGE_STATUS = 2
export const RED_STATUS = 3

// HOMEOWNER INDICATORS
export const POSSIBLE_GAIN = 'Possible gain'
export const POSSIBLE_LOSS = 'Possible loss'

// RENTER INDICATORS
export const POSSIBLY_SAVE = 'Possibly save'
export const POSSIBLY_LOSE = 'Possibly lose'

// BUDGET INDICATORS
export const OVER_BUDGET = 'Over budget'
export const UNDER_BUDGET = 'Under budget'
